<template>
  <footer class="enterprise-footer">
    <div class="enterprise-shell enterprise-footer__top">
      <div class="enterprise-footer__brand">
        <div class="enterprise-footer__brand-row">
          <img :src="logo" alt="Doclingo">
          <span>{{ t(isVipSite ? 'enterprise_home_footer_edition_cn' : 'enterprise_home_footer_edition_global') }}</span>
        </div>
        <p>
          {{ t(isVipSite ? 'enterprise_home_footer_description_cn' : 'enterprise_home_footer_description_global') }}
        </p>
      </div>

      <div class="enterprise-footer__column">
        <strong>{{ t('enterprise_home_footer_products') }}</strong>
        <NuxtLink :to="localePath('/account?menu=home')">{{ t('enterprise_home_footer_document') }}</NuxtLink>
        <NuxtLink :to="localePath('/account?menu=image')">{{ t('enterprise_home_footer_image') }}</NuxtLink>
        <NuxtLink :to="localePath('/account?menu=home&translate=text')">{{ t('enterprise_home_footer_text') }}</NuxtLink>
      </div>
      <div class="enterprise-footer__column">
        <strong>{{ t('enterprise_home_footer_solutions') }}</strong>
        <template v-if="isVipSite">
          <button type="button" @click="scrollTo('product-view')">{{ t('enterprise_home_footer_china_business') }}</button>
          <a :href="counterpartSiteUrl" target="_blank" rel="noopener noreferrer">{{ t('enterprise_home_footer_global_business') }}</a>
        </template>
        <template v-else>
          <a :href="counterpartSiteUrl" target="_blank" rel="noopener noreferrer">{{ t('enterprise_home_footer_china_business') }}</a>
          <button type="button" @click="scrollTo('product-view')">{{ t('enterprise_home_footer_global_business') }}</button>
        </template>
      </div>
      <div class="enterprise-footer__column">
        <strong>{{ t('enterprise_home_footer_support') }}</strong>
        <a :href="`mailto:${contactEmail}`">{{ t('enterprise_home_footer_email') }}</a>
        <button type="button" @click="openSupport">{{ t('enterprise_home_footer_online_support') }}</button>
      </div>
      <div class="enterprise-footer__column">
        <strong>{{ t('enterprise_home_footer_company') }}</strong>
        <NuxtLink :to="localePath('/account/agreement/userAgreement')">{{ t('enterprise_home_footer_terms') }}</NuxtLink>
        <NuxtLink :to="localePath('/account/agreement/userPrivacy')">{{ t('enterprise_home_footer_privacy') }}</NuxtLink>
      </div>
    </div>

    <div class="enterprise-shell enterprise-footer__bottom">
      <span>{{ t(isVipSite ? 'enterprise_home_footer_copyright_cn' : 'enterprise_home_footer_copyright_global', { email: contactEmail }) }}</span>
      <a :href="counterpartSiteUrl" target="_blank" rel="noopener noreferrer">
        {{ t(isVipSite ? 'enterprise_home_footer_visit_ai' : 'enterprise_home_footer_visit_vip') }} →
      </a>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useSiteConfig } from '~/config/useSiteConfig'
import logo from '~/assets/images/icon_logo.png'

const localePath = useLocalePath()
const { t } = useI18n()
const { isVipSite, counterpartSiteUrl } = useSiteConfig()
const { contactEmail } = useAppDomainConfig()

function scrollTo(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

function openSupport() {
  window.$crisp?.do?.('chat:open')
}
</script>
